"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.INPUT_THRESHOLD = void 0;
exports.INPUT_THRESHOLD = 0.1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5wdXRUaHJlc2hvbGQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29yZS9pbnB1dC9pbnB1dC1wcm9jZXNzb3JzL2dhbWVwYWQvaW5wdXRUaHJlc2hvbGQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRS9DLFFBQUEsZUFBZSxHQUFHLEdBQUcsQ0FBQyJ9